/**
 * pages.config.js - Page routing configuration
 *
 * The keys ARE the URL paths: the internal URL selector and the activity log
 * build their entries as "/<key>", so a key that doesn't match the real path
 * would produce a link that goes nowhere. Keys are therefore lowercase and
 * dashed, exactly like the route they open.
 *
 * Home (mainPage) is imported statically — it is the LCP-critical landing page.
 * All other pages are loaded via React.lazy so they are code-split into
 * separate chunks and only fetched on demand, shrinking the initial bundle.
 *
 * Activity detail pages (/<category-slug>/<activity-slug>) and collection
 * landing pages (/<slug>) are not listed here: both are served by dedicated
 * routes in App.jsx, because their path depends on the record they show.
 */
import { lazy } from 'react';
import Home from './pages/Home';

const ActivitiesList = lazy(() => import('./pages/ActivitiesList'));
const ActivityEdit = lazy(() => import('./pages/ActivityEdit'));

const AffiliateLinks = lazy(() => import('./pages/AffiliateLinks'));
const Ausflugsideen = lazy(() => import('./pages/Ausflugsideen'));
const BackendFilters = lazy(() => import('./pages/BackendFilters'));
const CategoryAdmin = lazy(() => import('./pages/CategoryAdmin'));
const Cookies = lazy(() => import('./pages/Cookies'));
const Magazin = lazy(() => import('./pages/Magazin'));
const PartnerWerden = lazy(() => import('./pages/PartnerWerden'));
const Rabatte = lazy(() => import('./pages/Rabatte'));
const SmartFilter = lazy(() => import('./pages/SmartFilter'));
const TourDetail = lazy(() => import('./pages/TourDetail'));
import __Layout from './Layout.jsx';

export const PAGES = {
    "activities-list": ActivitiesList,
    "activity-edit": ActivityEdit,

    "affiliate-links": AffiliateLinks,
    "ausflugsideen": Ausflugsideen,
    "backend-filters": BackendFilters,
    "category-admin": CategoryAdmin,
    "cookies": Cookies,
    "Home": Home,
    "magazin": Magazin,
    "partner-werden": PartnerWerden,
    "rabatte": Rabatte,
    "smart-filter": SmartFilter,
    "tour-detail": TourDetail,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};